module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_2.9c832ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_2.png
// module id = Hqkq
// module chunks = 0